angular.module('Iban', [])
    .service('Iban', Iban);

Iban.$inject = ['$rootScope','$stateParams', '$timeout', 'Pay', 'AmountCommission'];

function Iban($rootScope, $stateParams, $timeout, Pay, AmountCommission) {
    var iban = {

    isValidIBAN: function(iban) {
            var buffer = 0;
            var charCode;
            var CHAR_CODE_A = 'A'.charCodeAt(0);
            var CHAR_CODE_0 = '0'.charCodeAt(0);
            var isValid = false;

            if (/^UA\d{27}$/.test(iban)) {
                iban = iban.substr(4) + '3010' + iban.substr(2,2);

                for (var i = 0; i < iban.length; ++i) {
                    charCode = iban.charCodeAt(i);
                     buffer = charCode + (
                        charCode >= CHAR_CODE_A
                            ? buffer * 100 - CHAR_CODE_A + 10
                            : buffer * 10 - CHAR_CODE_0
                    );

                    if (buffer > 1000000) {
                        buffer %= 97;
                    }
                }

                isValid = (buffer % 97 === 1);
            }

            return isValid;
        }

    };
    return iban;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/iban/iban.js
 ** module id = 107
 ** module chunks = 1
 **/